export default "<h2>ERROR 404</h2>\r\n";